import { Component, Input, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
 
@Component({
    selector: 'app-roster-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
    constructor(private route: ActivatedRoute) {
    }

    termCode: string;
    crn: string;


    ngOnInit(): void {
        this.termCode = this.route.snapshot.paramMap.get('termCode');
        this.crn = this.route.snapshot.paramMap.get('crn');
    }
}
